module.exports = __webpack_public_path__ + "static/media/remote-sensing.7ba70fa7.png";